import { GameLayout } from "./GameLayout";
import { ModalProvider, StyleProvider } from "@bracket/ui";
import { useInOrOutStore } from "./store/InOrOutStore";
import { useEffect } from "react";

import { type Config as WagmiConfig } from "@wagmi/core";

type GameScreenProps = {
  wagmiConfig: WagmiConfig;
  address: string;
  user_stake?: bigint;
};

export const GameScreen = ({
  wagmiConfig,
  address,
  user_stake = BigInt(0),
}: GameScreenProps) => {

  const {
    initialized,
    initializing,
    socket,
    initialize,
    join,
    resetStore,
    updatedUserStake,
    user_stake: stored_user_stake,
  } = useInOrOutStore();

  useEffect(() => {
    if (!initialized && !initializing) {
      (async () => {
        await initialize(wagmiConfig, { user_stake, });
      })();
    }
  }, []);

  useEffect(() => {
    if (initialized && address && socket?.readyState === 1) {
      join(address);
    }
  }, [initialized, socket?.readyState]);

  useEffect(() => {
    return () => {
      console.log("Close socket on unmount");
      socket?.close();
      resetStore();
    };
  }, []);

  useEffect(() => {
    if(typeof user_stake === "bigint" && user_stake !== stored_user_stake) {
      updatedUserStake(user_stake);
    }
  }, [user_stake])

  return (
    <StyleProvider>
      <div id="game">
        <ModalProvider>
          <GameLayout />
        </ModalProvider>
      </div>
    </StyleProvider>
  );
};
